import MuiTabs from '@mui/material/Tabs';

import { styled } from 'helpers';

import { TableTabsProps } from './';

export const TableTabs = styled(MuiTabs)<TableTabsProps>`
  background-color: ${({ theme }) => theme.palette.background.default};
  min-height: 44px;

  .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.palette.blueGrey['A600']};
    bottom: auto;
    height: 2px;
    top: 0;
  }
`;
TableTabs.displayName = 'TableTabs';

export default TableTabs;
